import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function RemplacementTablier() {
  const checks = [
    "Diagnostic complet des lames endommagées",
    "Mesure précise des dimensions du tablier",
    "Choix du matériau adapté : PVC ou Aluminium",
    "Dépose du tablier existant sans abîmer le coffre",
    "Pose du nouveau tablier avec calibrage",
    "Test de montée, descente et enroulement",
  ];

  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Remplacement de tablier PVC ou Alu
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le choix du matériau du tablier dépend de plusieurs critères : la taille de la baie, l'exposition au vent, le niveau d'isolation souhaité et le budget. Le tablier en PVC est léger, économique et offre une bonne isolation thermique. Il convient aux fenêtres de taille standard et aux zones peu exposées au vent. Le tablier en aluminium est plus robuste, plus durable et résiste mieux aux grandes dimensions. Il est recommandé pour les baies vitrées larges et les zones venteuses du Bas-Rhin.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Notre technicien mesure la largeur et la hauteur de la baie, évalue le poids du tablier existant et vous conseille le matériau le plus adapté. Nous proposons des lames avec ou sans coeur isolant en mousse PU. Les lames isolantes améliorent le coefficient thermique du volet et réduisent les pertes de chaleur en hiver. Le remplacement d'un tablier complet dure généralement entre une et deux heures.
            </p>

            <ul className="space-y-3 mb-8">
              {checks.map((check) => (
                <li key={check} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#2F4A63] text-base">{check}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20replacing%20a%20complete%20white%20roller%20shutter%20tablier%20with%20new%20aluminum%20slats%20on%20a%20French%20house%20window%20using%20precision%20tools%20and%20clean%20work%20environment%20natural%20daylight%20professional%20service%20photography%20warm%20neutral%20tones&width=700&height=520&seq=tab-rempl&orientation=landscape" alt="Remplacement du tablier de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}